import React, { Suspense, lazy } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import Auth from '../../../../Layout/Auth';
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Import pages
const DiscountList = lazy(() => import('../Pages/DiscountList'));
const AddDiscount = lazy(() => import('../Pages/AddDiscount'));
const EditDiscount = lazy(() => import('../Pages/EditDiscount'));
const DiscountView = lazy(() => import('../Pages/DiscountView'));

/**
 * DiscountRoute component
 * Defines all routes related to the Discount module
 */
const DiscountRoute = ({ match }) => {
    const history = useHistory();
    const { path } = match;
    return (
        <Switch>
            <Route
                exact
                path={`${path}`}
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
                        <Suspense fallback={<Loading />}>
                            <Route exact path={`${path}`} component={DiscountList} />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path={`${path}/add`}
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
                        <Suspense fallback={<Loading />}>
                            <AddDiscount />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path={`${path}/edit/:slack`}
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
                        <Suspense fallback={<Loading />}>
                            <EditDiscount />
                        </Suspense>
                    </Auth>
                )}
            />
            <Route
                exact
                path={`${path}/view/:slack`}
                render={() => (
                    <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
                        <Suspense fallback={<Loading />}>
                            <DiscountView />
                        </Suspense>
                    </Auth>
                )}
            />
        </Switch>
    )
};
// Loading component
function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}

export default DiscountRoute;
